module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm06_pre1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f00vi-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_vm._v("Photo courtesy of the "), _c('span', {
    staticClass: "small"
  }, [_vm._v("LBJ")]), _vm._v(" School of Public Affairs, University of Texas at Austin.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('em', [_vm._v("Liberty lies in the hearts of men and women; when it dies there, no constitution, no law, no court can save it; no constitution, no law, no court can even do much to help it. While it lies there it needs no constitution, no law, no court to save it ….")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("The spirit of liberty is the spirit which is not too sure that it is right; the spirit of liberty is the spirit which seeks to understand the minds of other men and women; the spirit of liberty is the spirit which weighs their interests alongside its own without bias; the spirit of liberty remembers that not even a sparrow falls to earth unheeded; the spirit of liberty is the spirit of Him who, near two thousand years ago, taught mankind that lesson it has never learned, but has never quite forgotten; that there may be a kingdom where the least shall be heard and considered side by side with the greatest ….")])]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("JUDGE LEARNED HAND, MAY 21")]), _vm._v(", 1944"), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a164387","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm06_pre1.vue
// module id = 75
// module chunks = 0